var PrivacyConsentType = /* @__PURE__ */ ((PrivacyConsentType2) => {
  PrivacyConsentType2["Ccpa"] = "ccpa";
  PrivacyConsentType2["Gdpr"] = "gdpr";
  return PrivacyConsentType2;
})(PrivacyConsentType || {});
var PrivacyEvent = /* @__PURE__ */ ((PrivacyEvent2) => {
  PrivacyEvent2["InteractionComplete"] = "privacyInteractionComplete";
  PrivacyEvent2["ConsentUpdated"] = "privacyConsentUpdated";
  PrivacyEvent2["Shown"] = "privacyShown";
  PrivacyEvent2["Loaded"] = "privacyLoaded";
  PrivacyEvent2["Error"] = "privacyError";
  PrivacyEvent2["Back"] = "privacyBackEvent";
  return PrivacyEvent2;
})(PrivacyEvent || {});
var TcEvent = /* @__PURE__ */ ((TcEvent2) => {
  TcEvent2["InteractionComplete"] = "useractioncomplete";
  TcEvent2["TcLoaded"] = "tcloaded";
  TcEvent2["IsShown"] = "cmpuishown";
  return TcEvent2;
})(TcEvent || {});
var CmpApiVersion = /* @__PURE__ */ ((CmpApiVersion2) => {
  CmpApiVersion2[CmpApiVersion2["TcfApiVersion"] = 2] = "TcfApiVersion";
  CmpApiVersion2[CmpApiVersion2["UspApiVersion"] = 1] = "UspApiVersion";
  return CmpApiVersion2;
})(CmpApiVersion || {});
var CmpApi = /* @__PURE__ */ ((CmpApi2) => {
  CmpApi2["AddEventListener"] = "addEventListener";
  CmpApi2["GetTcData"] = "getTCData";
  CmpApi2["GetUSPData"] = "getUSPData";
  CmpApi2["GetCustomVendorConsents"] = "getCustomVendorConsents";
  CmpApi2["GetVendorList"] = "getVendorList";
  return CmpApi2;
})(CmpApi || {});
const ccpaOptOutToPrivacyString = (ccpaOptOut) => {
  if (ccpaOptOut === void 0) {
    return "1NNN";
  }
  if (ccpaOptOut) {
    return "1NYN";
  }
  return "1NNN";
};

export { CmpApi, CmpApiVersion, PrivacyConsentType, PrivacyEvent, TcEvent, ccpaOptOutToPrivacyString };
